import styled from "styled-components";
import logoSVG from "../assets/svg/logoSVG.svg";

export const Logo = styled.div`
  background-image: url(${logoSVG});
  height: 40px;
  width: 40px;
  background-repeat: no-repeat;
  cursor: pointer;
`;
